import { HStack, Image, StackProps } from "@chakra-ui/react"
import Link from "@pathwright/ux/src/components/link/Link"
import Tooltip from "@pathwright/ux/src/components/tooltip/Tooltip"
import { HomeRegistrationFragment } from "@pathwright/graphql-client/src/generated"
import { getRegistrationPathLink } from "../../utils"

function NestedPaths({
  nestedRegistrations,
  ...stackProps
}: {
  nestedRegistrations?: HomeRegistrationFragment[]
} & StackProps) {
  return nestedRegistrations?.length ? (
    <HStack
      maxW="100%"
      overflow="auto"
      bg="whiteAlpha.400"
      borderRadius="md"
      p={1}
      gap={1}
      {...stackProps}
    >
      {nestedRegistrations.map((registration) => (
        <Tooltip
          key={registration.id}
          title={registration.resource?.name!}
          fitContent
          popover={{
            openDelay: 300
          }}
        >
          <Link
            to={getRegistrationPathLink(registration)}
            cursor="pointer"
            lineHeight={0}
          >
            <Image
              src={registration.resource?.cover_image}
              maxW="3em"
              borderRadius="md"
              alignSelf="flex-start"
              // fallback={
              //   <Box w="3em" h="2.25em" bg="gray.200" borderRadius="md" />
              // }
              _hover={{
                opacity: ".8"
              }}
            />
          </Link>
        </Tooltip>
      ))}
    </HStack>
  ) : null
}

export default NestedPaths
